<template>
  <div class="custom-container">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Container'
}
</script>
